import * as notification from './notifications';
import {reportJobApplyEvent} from '../utils/analytics';

/**
 * The "save job" bookmark.
 *
 * A visitor who is not logged in is not intercepted: the bookmark is a link to
 * the save route, which walks them through the registration and saves the job
 * right after, through "redirect_after_login".
 *
 * For a logged-in job seeker the click toggles the saved state over the API.
 * The same handler powers the "Remove" action of the Saved Jobs account page,
 * which is a .job-save-btn.is-saved inside a [data-saved-job-row] element.
 */

const SELECTOR = '.job-save-btn';
const ROW_SELECTOR = '[data-saved-job-row]';

const showState = (button, saved) => {
  button.toggleClass('is-saved', saved);

  if (button.attr('aria-pressed') !== undefined) {
    button.attr('aria-pressed', saved ? 'true' : 'false');
  }

  const title = saved ? button.data('title-saved') : button.data('title-save');

  if (title) {
    button.attr('aria-label', title);
    button.find('.job-save-btn-label').text(title);
  }
};

/**
 * The same job can be on the page more than once, for example on the job
 * details page and in the related jobs list below it.
 */
const showStateOnEveryButtonOfJob = (jobId, saved) => {
  $(`${SELECTOR}[data-job-id="${jobId}"]`).each((index, element) => showState($(element), saved));
};

const removeRowFromSavedJobsPage = (button) => {
  const row = button.closest(ROW_SELECTOR);

  if (!row.length) {
    return false;
  }

  row.remove();

  // The page is empty now, so reload it to get the empty state, or the jobs of
  // the previous page when the list is paginated.
  if (!$(ROW_SELECTOR).length) {
    window.location.reload();

    return true;
  }

  return false;
};

const initPage = () => {
  $(document).on('click', SELECTOR, async function (event) {
    const button = $(this);

    if (+button.data('authed') !== 1) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    // A mouse click leaves the focus on the bookmark, and the ":focus-within"
    // rule would then keep it visible on a card the pointer already left. A
    // click made with the keyboard reports detail 0 and keeps its focus, which
    // is what makes the card reachable with the Tab key.
    if (event.detail > 0) {
      this.blur();
    }

    if (button.data('busy')) {
      return;
    }

    button.data('busy', true);

    const jobId = button.data('job-id');
    const isSaved = button.hasClass('is-saved');

    try {
      const response = isSaved
        ? await axios.delete(`/api/account/saved_jobs/${jobId}`)
        : await axios.post('/api/account/saved_jobs', {job_id: jobId});

      showStateOnEveryButtonOfJob(jobId, !isSaved);

      if (isSaved && removeRowFromSavedJobsPage(button)) {
        return;
      }

      if (response.data && response.data.message) {
        notification.success(response.data.message);
      }
    } catch (error) {
      const message = error.response && error.response.data && error.response.data.message;

      notification.danger(message || window.$jBoard.trans['general.error.something_went_wrong']);
    } finally {
      button.data('busy', false);
    }
  });

  $(document).on('click', '[data-saved-job-apply]', function () {
    const link = $(this);

    reportJobApplyEvent({id: link.data('job-id'), title: link.data('job-title')});
  });
};

$(initPage);
